<template>
  <span>
    <div v-if="uploadingFlag" class="loading-upload-container" />
    <form
      v-if="uploadingFlag === false"
      id="uploadForm"
      @submit.prevent="uploadFile"
    >
      <div class="drag-n-drop-container">
        <input
          type="file"
          class="file-input-main"
          name="file"
          multiple
          @change="onFileChange($event)"
        />
        <div class="file-upload-drag-n-drop">Drag and Drop File here</div>
      </div>
      <span v-if="uploadSuccess" class="tick-mark-uploaded">&#10004;</span>
    </form>
  </span>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      responseFiles: undefined,
      formData: undefined,
      uploadingFlag: false,
      uploadSuccess: false,
    }
  },
  mounted() {
    this.formData = new FormData()
  },
  methods: {
    onFileChange(event) {
      this.formData = new FormData()
      this.uploadSuccess = false
      this.$emit("codingFileChanged")
      for (let i = 0; i < event.target.files.length; i++) {
        this.formData.append("file", event.target.files[i])
      }
      this.uploadFile()
    },
    uploadFile() {
      this.uploadingFlag = true
      this.axios
        .post(`${siteConfig.siteURL}uploads/question/game`, this.formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-access-token": localStorage.token,
          },
        })
        .then(res => {
          this.uploadSuccess = true
          if (res.data.data.success.length >= 1) {
            this.$emit("codingFileUploadSuccess", res.data.data.success[0])
          }
          this.uploadingFlag = false
        })
        .catch(() => {
          this.uploadingFlag = false
        })
    },
  },
}
</script>

<style>
.file-input-main {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.drag-n-drop-container {
  display: inline-block;
  position: relative;
  width: 300px;
  height: 100px;
  background-color: green;
}
.file-upload-drag-n-drop {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 36px;
  border: 1px dotted black;
  background-color: #d5f7ad;
  font-weight: 700;
  text-align: center;
  pointer-events: none;
}
.tick-mark-uploaded {
  position: relative;
  top: -40px;
  left: 10px;
  padding-left: 10px;
  color: #4caf50;
  font-size: 2em;
}
</style>
